import React from 'react';

const QuotIcon = ({ className = '' }): JSX.Element => (
  <svg
    className={className}
    width="22"
    height="15"
    viewBox="0 0 22 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.52 14.6868H9.032L10.152 0.798777H3.992L0.52 14.6868ZM11.664 14.6868H20.176L21.296 0.798777H15.136L11.664 14.6868Z"
      fill="currentColor"
    />
  </svg>
);

export default QuotIcon;
